import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import CaseUserStatModel from "../../models/case-user-stat";

export default class CaseUserStatRepository extends BaseRepository {
  static modelClass = CaseUserStatModel;
  modelName = "case-user-stat";

  async findRecord(params) {
    const onlyUserStatParams = {};
    for (const key in params) {
      if (
        key === "overall_status" ||
        key === "overall_status__in" ||
        key === "status" ||
        key === "status_in"
      ) {
        onlyUserStatParams[key] = params[key];
      }
    }

    return await super.findRecord(1, {
      urlPath: CaseUserStatModel.urlPath + "?" + qs.stringify(onlyUserStatParams),
    });
  }
}
